// removed by extract-text-webpack-plugin
module.exports = {"container":"_2oTE6TJDzcwzzzc6yEHk02","button":"_1LSXRalJCNv1Y_Go5Caq-k","icon1":"Qor9QGqmyH891B7w7W6fd","icon2":"_1HdOJ3FJGqrbxOkOJqDT7Z","icon3":"_3PEE-mW0WLy9G_YA_METhq","title":"_2-QLzEnbubLSc7yR24FD_G"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/UserInformation/UserDocuments/styles.css
// module id = 3160
// module chunks = 0